export const locales = {
  en: "english",
  fi: "suomi",
  de: "deutsch",
  ru: "russian",
  es: "spanish",
  da: "danish",
  pt: "portuguese"
};
